export default `float h,d=1.,i,u,s, t = 0.8; 
    p+=vec3(1.0,1.0,sin(t/4.)*3.);
    s=2.;
    for(int j=0;j<9;j++){
      p.xy*=rotate2D(t/4.);
      u=4./3./dot(p,p);
      s*=u;
      p=mod(1.-p*u,2.)-1.;
    }
    return (length(p)/s);
  }`